import { createTheme } from '@mui/material/styles';
import { CustomCheckboxIcon, CustomCheckboxCheckedIcon } from './components/customCheckbox';
import CustomDropdownIcon from "./components/CustomDropdownIcon";

const theme = createTheme({
  typography: {
    fontFamily: 'Sora, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
          root: {
              boxShadow: "none",
              "&:hover": {
                  boxShadow: "none",
              }
          }
      }
    },
    MuiDivider: {
      styleOverrides: {
          root: {
              borderWidth: "0 0 thin 0 !important",
              borderColor: "#EFEDED",
              margin: "0",
          },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        icon: <CustomCheckboxIcon />,
        checkedIcon: <CustomCheckboxCheckedIcon />,
      },
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& input:-webkit-autofill": {
            backgroundColor: "transparent !important",
            boxShadow: "0 0 0px 1000px white inset !important",
            transition: "background-color 5000s ease-in-out 0s !important",
          },
          "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
          },
          "& input[type=number]": {
            "-moz-appearance": "textfield",
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "& input:-webkit-autofill": {
            backgroundColor: "transparent !important",
            boxShadow: "0 0 0px 1000px white inset !important",
            transition: "background-color 5000s ease-in-out 0s !important",
          },
          "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
          },
          "& input[type=number]": {
            "-moz-appearance": "textfield", // Firefox ke liye
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& input:-webkit-autofill": {
            backgroundColor: "transparent !important",
            boxShadow: "0 0 0px 1000px white inset !important",
            transition: "background-color 5000s ease-in-out 0s !important",
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {        
        "::-webkit-scrollbar": {
          width: "4px",
          height: "3px",
        },
        "::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "4px",
        },
        "::-webkit-scrollbar-track": {
          backgroundColor: "#f1f1f1",
        },
      },
    },
    MuiTouchRipple: {
      styleOverrides: {
        root: {
          display: "none",
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: CustomDropdownIcon,
      },
      styleOverrides: {
        root: {
          // extra guarantee — target the icon inside Select root
          "& .MuiSelect-icon": {
            right: 12,
            width: 10,
            height: 6,
            top: "50%",
            transform: "translateY(-50%)",
          },
        },
        icon: {
          // fallback for some variants
          right: 12,
          width: 10,
          height: 6,
          top: "50%",
          transform: "translateY(-50%)",
        },
      },
    },
    MuiNativeSelect: {
      defaultProps: {
        IconComponent: CustomDropdownIcon,
      },
      styleOverrides: {
        root: {
          "& .MuiNativeSelect-icon": {
            right: 12,
            width: 10,
            height: 6,
            top: "50%",
            transform: "translateY(-50%)",
          },
        },
        icon: {
          right: 12,
          width: 10,
          height: 6,
          top: "50%",
          transform: "translateY(-50%)",
        },
        iconOutlined: {
          right: 12,
          width: 10,
          height: 6,
          top: "50%",
          transform: "translateY(-50%)",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          // ensure the icon placed by the input wrapper also gets positioned
          "& .MuiNativeSelect-icon, & .MuiSelect-icon": {
            right: 18,
            width: 10,
            height: 6,
            top: "50%",
            transform: "translateY(-50%)",
          },
        },
      },
    },
  },
});

export default theme;
